import { render } from "./Frame.vue?vue&type=template&id=74bc334d&scoped=true&ts=true"
import script from "./Frame.vue?vue&type=script&lang=ts"
export * from "./Frame.vue?vue&type=script&lang=ts"

import "./Frame.vue?vue&type=style&index=0&id=74bc334d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bc334d"]])

export default __exports__